//vehicle details, status message, help text, call me
import React, { Component } from "react";
import { connect } from "react-redux";
import { goToView } from "../../redux/actions/ui";
import Logo from "../../components/help/Logo";
import StatusMessage from "../../components/help/StatusMessage";
import AdditionalText from "../../components/help/AdditionalText";
import VehicleDetails from "../../components/help/VehicleDetails";
import HorizontalLine from "../../components/help/HorizontalLine";
import CallMe from "../../components/help/CallMe";
import { onCallMeClick } from "../../redux/actions/infoHelp";
import Icon from "@material-ui/core/Icon";
import "./InfoHelp.css";
import renderIf from "../../utils/renderIf";
import locale from "../../utils/locale";

class InfoHelpView extends Component {
  goToPage = () => {
    this.props.goToView("PickupFormView");
  };

  render() {
    const { lot, statusMessage, messageType, helpText, callMe, onCallMeClick, apiProcessing } = this.props;

    return (
      <div className="info-page">
        {renderIf(callMe)(<a className="close-btn" onClick={this.goToPage}>
          <Icon>{locale("close")}</Icon>
        </a>)}
        <VehicleDetails
          year={lot.year}
          color={lot.color}
          make={lot.make}
          model={lot.model}
          referenceNumber={lot.referenceNumber}
        />

        <StatusMessage message={statusMessage} messageType={messageType} />
        <HorizontalLine />
        <AdditionalText text={helpText} />
        <CallMe
          show={callMe}
          onCallMe={onCallMeClick}
          disable={apiProcessing}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  lot: state.lot,
  statusMessage: state.infoHelp.statusMessage,
  helpText: state.infoHelp.helpText,
  callMe: state.infoHelp.callMe,
  apiProcessing: state.ui.apiProcessing,
  messageType: state.pickupForm.messageType
});
const mapDispatchToProps = {
  goToView,
  onCallMeClick
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoHelpView);



// WEBPACK FOOTER //
// ./src/containers/InfoHelp/index.js